(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;

  var brandText = header.querySelector('[data-header-brand-text]');
  var menuToggle = header.querySelector('[data-header-menu-toggle]');
  var menuPanel = header.querySelector('[data-header-menu-panel]');
  var cartLink = header.querySelector('[data-header-cart-link]');
  var cartToast = document.querySelector('[data-header-cart-toast]');
  var cartToastCount = cartToast && cartToast.querySelector('[data-header-cart-toast-count]');
  var cartToastTimer = null;
  var TOAST_VISIBLE_MS = 2400;

  // Replay the digit pop-in (transitions-dev 02-number-pop-in.md): rebuild the badge as one
  // span per character so each digit can animate in independently, last digit trailing the
  // rest by a beat. Safe to call on every update, including the first time the badge appears.
  function setBadgeDigits(badge, value) {
    badge.classList.remove('is-animating');
    badge.textContent = '';
    var chars = String(value).split('');
    chars.forEach(function (ch, i) {
      var span = document.createElement('span');
      span.className = 't-digit';
      span.textContent = ch;
      if (i === chars.length - 1 && chars.length > 1) span.dataset.stagger = '1';
      badge.appendChild(span);
    });
    void badge.offsetWidth; // force reflow so the animation replays on back-to-back adds
    badge.classList.add('is-animating');
  }

  function showCartToast(count) {
    if (!cartToast) return;
    if (cartToastCount) cartToastCount.textContent = count;
    cartToast.classList.add('is-visible');
    clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(function () {
      cartToast.classList.remove('is-visible');
    }, TOAST_VISIBLE_MS);
  }

  // Keep the cart badge in sync with AJAX adds from elsewhere on the page (e.g. a product
  // carousel's quick-add button), without a full page reload. Shared pubsub bus already used
  // site-wide by Dawn's cart/product scripts (see assets/constants.js, assets/pubsub.js).
  //
  // Two different confirmations depending on whether the header is on screen: if it's visible,
  // the badge's own pop-in is confirmation enough — nothing else appears. If the header has
  // scrolled out of view (see the hide/show logic below), a small floating toast stands in for
  // it briefly, since there's no badge on screen to notice otherwise.
  function applyCartCount(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    var badge = cartLink.querySelector('[data-header-cart-count]');

    if (cart.item_count <= 0) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('data-header-cart-count', '');
      cartLink.appendChild(badge);
    }

    setBadgeDigits(badge, cart.item_count);
    badge.classList.remove('is-bumped');
    void badge.offsetWidth;
    badge.classList.add('is-bumped');
    setTimeout(function () {
      badge.classList.remove('is-bumped');
    }, 300);

    if (header.classList.contains('is-hidden')) {
      showCartToast(cart.item_count);
    }
  }

  if (cartLink && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (!cart) return;

      if (typeof cart.item_count === 'number') {
        applyCartCount(cart);
        return;
      }

      // Dawn's own product-form.js (the stock product-page "Add to cart" handler) publishes
      // the raw /cart/add.js response here — a single line-item object with no item_count.
      // Every other add-to-cart entry point on the site (assets/product-card.js, shared by the
      // catalog grid and homepage carousel) already re-fetches the full cart before publishing
      // to satisfy this badge; do the same
      // fallback here instead of forking Dawn's file too, so the real product page's Add to
      // cart button gets the same confirmation as everywhere else.
      fetch(routes.cart_url + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(applyCartCount);
    });
  }

  // Measure the text's natural width up front (stays collapsed until the menu opens)
  var brandNaturalWidth = brandText ? brandText.scrollWidth : 0;
  if (brandText) brandText.style.maxWidth = '0px';

  // Recalculate on resize in case layout/font changes shift the text width
  var resizeTimeout;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      if (!brandText) return;
      var wasRevealed = brandText.classList.contains('is-revealed');
      var prevMaxWidth = brandText.style.maxWidth;
      brandText.style.maxWidth = 'none';
      brandNaturalWidth = brandText.scrollWidth;
      brandText.style.maxWidth = wasRevealed ? brandNaturalWidth + 'px' : prevMaxWidth;
    }, 150);
  });

  // --- Menu dropdown, with brand reveal tied to open/close ---
  function openMenu() {
    menuPanel.classList.add('is-open');
    // `inert`, not aria-hidden: the closed panel is only faded out (opacity 0), so its links stayed
    // keyboard-focusable inside an aria-hidden container (an accessibility violation). inert takes
    // them out of both the tab order and the accessibility tree; the fade still plays.
    menuPanel.inert = false;
    menuToggle.setAttribute('aria-expanded', 'true');

    if (brandText) {
      brandText.style.maxWidth = brandNaturalWidth + 'px';
      brandText.classList.add('is-revealed');
    }
  }

  function closeMenu() {
    menuPanel.classList.remove('is-open');
    menuPanel.inert = true;
    menuToggle.setAttribute('aria-expanded', 'false');

    if (brandText) {
      brandText.style.maxWidth = '0px';
      brandText.classList.remove('is-revealed');
    }
  }

  // Exposed so assets/page-transitions.js can fold the menu back after intercepting a nav-link
  // click: normally following a link unloads the page, which closes everything for free — once
  // that click is preventDefault()'d for a client-side swap instead, nothing else here would
  // ever think to close the menu, since the click originated *inside* the header (the outside-
  // click listener below only fires for clicks that land outside it).
  window.CowalkiesHeader = window.CowalkiesHeader || {};
  window.CowalkiesHeader.closeMenu = closeMenu;

  if (menuToggle && menuPanel) {
    menuToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = menuPanel.classList.contains('is-open');
      if (isOpen) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  // --- Homepage intro: play the same logo|name reveal once on load, unprompted, then fold it
  // back — a first impression of the brand name rather than a hint that only ever appears once
  // you've found the menu button. Reuses the exact reveal the menu already drives (same classes,
  // same CSS transition speeds) so it reads as one consistent motion, just two different triggers.
  if (header.hasAttribute('data-header-auto-reveal') && brandText) {
    var AUTO_REVEAL_DELAY = 300; // ms before the reveal starts, so it doesn't fire mid-layout
    var AUTO_REVEAL_HOLD = 1800; // ms the name stays expanded before folding back

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(function () {
        brandText.style.maxWidth = brandNaturalWidth + 'px';
        brandText.classList.add('is-revealed');

        setTimeout(function () {
          // A visitor who already opened the menu during the hold owns the reveal state now —
          // don't yank it away out from under them.
          if (menuPanel && menuPanel.classList.contains('is-open')) return;
          if (!brandText.classList.contains('is-revealed')) return;

          brandText.style.maxWidth = '0px';
          brandText.classList.remove('is-revealed');
        }, AUTO_REVEAL_HOLD);
      }, AUTO_REVEAL_DELAY);
    }
  }

  // --- Scroll hide/show: header (and dropdown with it) hides on scroll down, shows on scroll up.
  // The background fade and top offset are separate, simpler boundary checks (past a fixed
  // threshold, yes or no) rather than a value recalculated every pixel of scroll — that continuous
  // per-frame math (plus the announcement bar's own animation, now removed entirely) is what read
  // as twitchy before. Each of the three only ever changes at the moment it actually crosses its
  // own threshold, so their CSS transitions settle cleanly instead of fighting values still being
  // rewritten underneath them.
  var SCROLL_THRESHOLD = 5;
  var BG_SWITCH_THRESHOLD = 40;
  // The announcement bar's own height, read from the CSS variable it set once (synchronously,
  // before this deferred script even runs) - see blocks/announcement-bar.liquid. Once scrolled
  // at least this far, the bar itself has scrolled out of view, so the header can drop to top: 0.
  var announcementBarHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ai-header-top-offset')) || 0;
  var lastScroll = window.pageYOffset;
  var ticking = false;
  var BOTTOM_ZONE = 140; // px from the end of the page — covers the iOS toolbar growing back in
  var BOUNCE_GUARD_MS = 900;
  var bounceGuardUntil = 0;
  window.addEventListener('touchstart', function () { bounceGuardUntil = 0; }, { passive: true });

  function onScroll() {
    var currentScroll = window.pageYOffset;
    // iOS rubber-bands past the end of the page: pageYOffset climbs above the real maximum while
    // you keep pushing and then drops back as it springs home. That bounce-back is a "scroll up" as
    // far as the delta below can tell, so the header slid in and then hid again on the next push —
    // a visible flap on every page with a solid header (the homepage's transparent overlay header
    // hides it). At or past the bottom the header just stays as it is; a genuine scroll up from
    // there is still caught on the first event that lands above the bottom.
    var maxScroll = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
    var atBottom = currentScroll >= maxScroll - 1;
    var delta = Math.min(currentScroll, maxScroll) - lastScroll;

    // A fast fling into the bottom is the same bounce with a twist: iOS brings its bottom toolbar
    // back as the page hits the end, which shrinks innerHeight, so the real maximum above is
    // suddenly up to a toolbar-height *further* than where the page actually stopped and the
    // spring-back lands "above the bottom". So reaching the last stretch of the page (while moving
    // down) arms a short guard: upward movement inside it is the bounce, not the shopper, and is
    // ignored. A new finger touch ends the guard at once, so a real scroll up still shows the
    // header immediately.
    var now = Date.now();
    if (currentScroll >= maxScroll - BOTTOM_ZONE && delta >= 0) bounceGuardUntil = now + BOUNCE_GUARD_MS;
    var bouncing = delta < 0 && now < bounceGuardUntil;

    if (currentScroll <= 0) {
      header.classList.remove('is-hidden');
    } else if (atBottom || bouncing) {
      // leave is-hidden exactly as it is
    } else if (delta < 0) {
      // Any upward scroll (swipe up to go back toward the top) - show immediately, no threshold
      header.classList.remove('is-hidden');
    } else if (delta > SCROLL_THRESHOLD) {
      if (menuPanel && menuPanel.classList.contains('is-open')) {
        // The menu is open: let its own reverse (close) animation play out fully first,
        // instead of yanking the whole header away mid-transition, which cut the close
        // animation short and made it look like the menu just vanished. The header hides
        // on a later scroll tick instead, once the menu has already folded back into the icon.
        closeMenu();
      } else {
        // Scrolling down past the threshold - hide
        header.classList.add('is-hidden');
      }
    }

    header.classList.toggle('is-scrolled', currentScroll > BG_SWITCH_THRESHOLD);

    var offset = currentScroll >= announcementBarHeight ? 0 : announcementBarHeight;
    document.documentElement.style.setProperty('--ai-header-top-offset', offset + 'px');

    lastScroll = currentScroll <= 0 ? 0 : Math.min(currentScroll, maxScroll);
    ticking = false;
  }

  // Sync state immediately on load (e.g. page restored mid-scroll) instead of waiting for the first scroll event
  onScroll();

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();
